import * as React from "react";
const SvgRadio = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 9, r: 8.5, fill: "#fff", stroke: "currentColor" }));
export default SvgRadio;
